import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  FormHelperText
} from "@mui/material";
import SubmissionStatusModal from "../../../components/popup-modal/submitStatusModal";
import ClientAPI from "../../../api/clientApi";
const AddMoreIdsModal = ({
  isOpen,
  onClose,
  subscriptionData,
  afterSubmit,
}) => {
  const [numIds, setNumIds] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false); // For SubmissionStatusModal
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(""); // Error state for validation

  useEffect(() => {
    if (isOpen && subscriptionData) {
      setNumIds(subscriptionData.numIds || "");
      setError(""); // Clear any existing error when the modal opens
    }
  }, [isOpen, subscriptionData]);

  const handleCloseModal = () => {
    setModalOpen(false);
    onClose(); // Ensure the main dialog closes after submission.
  };

  const handleSubmit = async () => {
    if (!numIds) {
      setError("This field is required"); // Show error if the field is empty
      return;
    }
    if (!subscriptionData?.id) {
      subscriptionData.id = 1; // Set Subscription ID to 1 as default.
    }
    const userCountData = {
      id: subscriptionData.id,
      totalNumberOfUser: numIds,
    };
    try {
      setIsSubmitting(true);
      const result = await ClientAPI.updateSubscriptionUserCount(userCountData);

      const successMessage =
        result.message === "No response body was returned."
          ? "User count updated successfully"
          : result.message || "User count updated successfully";
      setIsSuccess(true);
      setMessage(`${successMessage}`);

      afterSubmit(); // Trigger any additional actions on success.
      if (result.statusCode==="FAILED"){
        setIsSuccess(false);
      setMessage(result.message);

      }
    } catch (error) {
      setIsSuccess(false);
      setMessage(error.message);
      setError("");
    } finally {
      setIsSubmitting(false);
      setModalOpen(true); // Show status modal.
    }
  };
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose(); 
  };
  return (
    <>
      <Dialog open={isOpen} onClose={handleClose} fullWidth>
        <DialogTitle>
          <Typography variant="h6" align="center" style={{ color: "red" }}>
            Add Additional IDs
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            margin="normal"
            fullWidth
            id="numIds"
            label="Number of IDs"
            variant="outlined"
            value={numIds}
            onChange={(e) => {
              const value = e.target.value;
              if (
                /^\d*$/.test(value) &&
                (value === "" || value[0] !== "0") &&
                value.length <= 10
              ) {
                setNumIds(value);
                setError(""); // Clear error on valid input
              } else if (value[0] === "0") {
                setError("Value cannot start with 0");
              }
            }}
            onKeyDown={(e) => {
              // Prevent 'e', 'E', '+', '-', '.' and prevent '0' as the first character
              if (
                ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(
                  e.key
                ) ||
                (e.key === "0" && numIds === "")
              ) {
                e.preventDefault();
              }
            }}
            inputProps={{
              inputMode: "numeric", // Ensures numeric keyboard on mobile
              pattern: "[1-9][0-9]*", // Ensures valid positive numbers
            }}
            required
            error={!!error} // Show error style if there's an error
            helperText={error} // Display error message if there's an error
          />
            <FormHelperText style={{ color: "#666", marginLeft: "10px" }}>
          How many IDs do you want to add?
        </FormHelperText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} style={{ color: "red" }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            style={{ backgroundColor: "red", color: "white" }}
            variant="contained"
            disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <SubmissionStatusModal
        open={modalOpen}
        onClose={handleCloseModal}
        isSuccess={isSuccess}
        message={message}
      />
    </>
  );
};

export default AddMoreIdsModal;
